module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRAgMAAAA4I8mbAAAACVBMVEX///+FhYWAgICko1U2AAAAAXRSTlMAQObYZgAAACZJREFUOMtjWIUFMDQwYACmUcFRwVFBnIJTQzFAGMMoGAWjgGIAALExJ/w2ePm7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/tree-bottom.png
// module id = 223
// module chunks = 0